import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/app/AppShell';
import { RequireAccess } from '@/app/RequireAccess';
import { RequireSession } from '@/app/RequireSession';
import { APP_ROUTES } from '@/app/routes';
import { ApplicantSignInPage } from '@/pages/apply/ApplicantSignInPage';
import { ApplyPage } from '@/pages/apply/ApplyPage';
import { RequireApplicant } from '@/pages/apply/RequireApplicant';
import { LandingPage } from '@/pages/landing/LandingPage';
import { SignInPage } from '@/pages/signin/SignInPage';

/**
 * The route tree, apart from the router itself so a test can mount it inside a
 * MemoryRouter at any path.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signin" element={<SignInPage />} />
      {/* Applicants: their own sign-in and their own pages, outside the staff shell. */}
      <Route path="/apply/signin" element={<ApplicantSignInPage />} />
      <Route
        path="/apply"
        element={
          <RequireApplicant>
            <ApplyPage />
          </RequireApplicant>
        }
      />
      <Route
        element={
          <RequireSession>
            <AppShell />
          </RequireSession>
        }
      >
        {APP_ROUTES.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RequireAccess route={route}>{route.element}</RequireAccess>}
          />
        ))}
      </Route>
      {/* An unknown path goes to the landing page rather than nowhere. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
